import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCalendar = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 18 18",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M12 .75c.414 0 .75.336.75.75v.75h1.5c1.243 0 2.25 1.007 2.25 2.25V15c0 1.243-1.007 2.25-2.25 2.25H3.75c-1.243 0-2.25-1.007-2.25-2.25V4.5c0-1.243 1.007-2.25 2.25-2.25h1.5V1.5c0-.38.282-.693.648-.743L6 .75c.414 0 .75.336.75.75v.75h4.5V1.5c0-.38.282-.693.648-.743zm3 7.5H3V15c0 .414.336.75.75.75h10.5c.414 0 .75-.336.75-.75V8.25zm-9.75-4.5h-1.5c-.414 0-.75.336-.75.75v2.25h12V4.5c0-.414-.336-.75-.75-.75h-1.5v.75c0 .38-.282.693-.648.743L12 5.25c-.414 0-.75-.336-.75-.75v-.75h-4.5v.75c0 .38-.282.693-.648.743L6 5.25c-.414 0-.75-.336-.75-.75v-.75z"
	})
});
export default SvgCalendar;
